export default "__VITE_ASSET__0hOYKziZ__"